import { createTheme } from "@mui/material/styles";
import { red } from "@mui/material/colors";

// Extend MUI Palette to include custom colors
declare module "@mui/material/styles" {
  interface Palette {
    custom: {
      purple: string;
      white: string;
      black: string;
      whitetype: string;
      smoke: string;
      orange: string;
      green: string;
      blue: string;
      red: string;
      gray: string;
      cloudy: string;
      lightgreen: string;
      lightsmoke: string;
    };
  }
  interface PaletteOptions {
    custom?: {
      purple?: string;
      white?: string;
      black?: string;
      whitetype?: string;
      smoke?: string;
      orange?: string;
      green?: string;
      blue?: string;
      red?: string;
      gray?: string;
      cloudy?: string;
      lightgreen?: string;
      lightsmoke?: string;
    };
  }
}

// Create a theme instance.
const theme = createTheme({
  palette: {
    primary: {
      main: "#1e2a78",
      light: "#fff",
      dark: "#4caf50",
      100: "#EFF5F0",
      200: "#EFF5FF",
    },
    secondary: {
      main: "#4E4E4E",
      light: "#EDEDED",
      "100": "#F5F5F5",
      "200": "#F2F2F2",
      "300": "#E2E2E2",
    },
    custom: {
      purple: "#D7ADDB",
      white: "#fff",
      black: "#000",
      whitetype: "#e0e0e0",
      smoke: "#fcf8f5",
      orange: "#EF9B54",
      green: "#1A993A",
      blue: "#333888",
      red: "#D11425",
      gray: "#999999",
      cloudy: "#ccc",
      lightgreen: "#1e8e3e",
      lightsmoke: "#E3E3E3",
    },

    error: {
      main: red.A400,
    },
  },
  typography: {
    fontFamily: "Noto Sans JP ",
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    allVariants: {
      fontWeight: 500,
    },
    //@ts-ignore
    fonts: {
      outfit: "Outfit",
    },
  },
});

export default theme;
